<template>
    <!-- Intro section -->
	<section class="intro-section spad">
		<div class="container">
			<div class="row">
				<div class="col-lg-5">
					<img :src="imageUrl" class="intro" :alt="title + ' - יעל תמם מאפרת מקצועית באשדוד'" loading="lazy"/>
				</div>
				<div class="col-lg-7 intro-text">
					<span v-if="titlePrefix">{{titlePrefix}}</span>
					<h1>{{title}}</h1>
					<p v-if="quote" class="intro-quote"><em>{{quote}}</em></p>
					<p v-html="body"></p>
					<!--<a href="#" class="site-btn sb-dark">קרא עוד <i class="fa fa-angle-double-left"></i></a>-->
					<a href="#contact"><button class="site-btn sb-dark">צרי קשר <i class="fa fa-angle-double-left"></i></button></a>
				</div>
			</div>
		</div>
	</section>
	<!-- Intro section end-->
</template>
<script>
    export default {
        name: 'IntroPage',
		props: {
            titlePrefix : String,
			title: String,
			quote: String,
			body: String,
			imageUrl: String
		}
	}
</script>

<style scoped>
	img.intro {
		max-width: 100%;
		max-height: 380px;
		width: auto;
		height: auto;
		object-fit: contain;
		display: block;
		margin: 0 auto;
	}
	.intro-quote {
		color: #ff006c;
		font-size: 1.1rem;
		margin-bottom: 15px;
	}
</style>